import { createContext } from "reka-ui";
import type { Ref } from "vue";

export const [injectTrayContext, provideTrayContext] = createContext<{
  isCompact: Ref<boolean> | false;
}>("Tray");
